const PropTypes = require('prop-types');
// @vendors
const React = require('react');
// @commons
const { PopoverMenu } = require('commonsComponents/popoverMenu');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @helpers
const { i18n:{ FormattedText } } = require('core/i18n');
// @ utilities
const { removeCurrentSectionOption } = require('utilities/moreOptionsHelper');

class ActionsTableCell extends React.Component {

    renderTargeElement = () => {
        const { translationKey } = this.props;

        return (
            <div>
                <OKButton
                    modifier="ghost"
                    rightIcon="icon-dropdown-abrir"
                    smallRightIcon={true}
                >
                    <FormattedText value={`${translationKey}`} />
                </OKButton>
            </div>
        )
    }

    render() {
        const { options } = this.props;

        return (
            <PopoverMenu
                target={this.renderTargeElement()}
                items={removeCurrentSectionOption(options)}
                placement="bottomRight"
            />
        );
    }
}

ActionsTableCell.propTypes = {
    options: PropTypes.array.isRequired,
    translationKey: PropTypes.string.isRequired
};

export default ActionsTableCell;